import React, {Component} from 'react';
import ViewRenderer from './views';
import {API} from '../../../requests';
import 'react-datasheet/lib/react-datasheet.css';
import './styles.css';
import moment from 'moment';
import PopupContainer from '../../../components/PopupContainer';
import POPUP_CONSTANTS from '../../../constants/popup-constants';
import Spinner from '../../../components/Spinner';
import Popup from '../../../components/SimplePopup';

import strings from '../../../globalization';
import util from '../../../util';

import {commonImages} from '../../../assets/images';
class PassAuditReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      startDate: moment().subtract(1, 'month'),
      endDate: moment().add(1, 'day'),
      dates: {
        start: moment().subtract(1, 'month').format('MM-DD-YYYY'),
        end: moment().add(1, 'day').format('MM-DD-YYYY'),
      },
      passAuditReport: [],
      filterPassAuditReport: [],
    };
  }
  showSpinner = () => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SPINNER_POPUP,
      },
    });
  };

  getData = async () => {
    this.showSpinner();
    const {startDate, endDate} = this.state;

    if (!startDate || !endDate) {
      this.showErrorPopup(`Date and Time parameters cannot be empty!`);
      return;
    }

    let params = {
      startDate: `${moment(startDate).format('MM-DD-YYYY')}`,
      endDate: `${moment(endDate).format('MM-DD-YYYY')}`,
    };
    console.log('params...', params);
    API.fetchPassAuditReportData(params)
      .then(res => {
        const data = res.data.map(dateFormate => {
          return {
            ...dateFormate,
            date: moment(dateFormate['date']).format('MMMM Do YY h: mm a'),
          };
        });
        console.info('data', data);
        this.setState(
          {
            passAuditReport: data,
            filterPassAuditReport: data,
            popup: null,
          },
          this.applyFilters,
        );
      })
      .catch(err => {
        console.log('err', err);
        const error = util.getErrorMessage(err);
        this.showErrorPopup(error);
      });
  };
  resetData = () => {
    this.setState(
      {
        searchText: '',
        startDate: moment().subtract(1, 'month'),
        endDate: moment().add(1, 'day'),
        dates: {
          start: moment().subtract(1, 'month').format('MM-DD-YYYY'),
          end: moment().add(1, 'day').format('MM-DD-YYYY'),
        },
      },
      this.getData,
    );
  };
  showErrorPopup = errorMsg => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: errorMsg,
        messageStyle: {color: '#E67717'},
        headingImage: commonImages.errorIcon,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: this.onClose,
          },
        ],
        onClose: this.closePopup,
      },
    });
  };

  onClose = () => {
    this.setState({
      popup: null,
    });
  };
  onClickHandler = (action, data) => {
    switch (action) {
      case 'apply': {
        this.getData();
        break;
      }
      case 'clearFilters': {
        this.resetData();
        break;
      }

      default: {
        console.info('tableActionHandler case not handled', action);
      }
    }
  };

  onChangeHandler = (action, data) => {
    switch (action) {
      case 'date': {
        const {startDate, endDate, dates} = data;
        this.setState({
          startDate,
          endDate,
          dates,
        });
        break;
      }

      case 'search': {
        this.setState(
          {
            searchText: data,
          },
          this.applyFilters,
        );

        break;
      }

      default: {
        console.info('case not handled', action);
      }
    }
  };

  getProps = () => {
    const {searchText, filterPassAuditReport, startDate, endDate, dates} =
      this.state;
    return {
      onChange: this.onChangeHandler,
      onClick: this.onClickHandler,
      passAuditReport: filterPassAuditReport,
      startDate,
      endDate,
      dates,
      searchText,
    };
  };
  applyFilters = () => {
    const {searchText, passAuditReport} = this.state;
    console.log('mySearchText', searchText);
    const finalFilterData =
      passAuditReport.filter(element =>
        Object.values(element)
          .toString()
          .toLowerCase()
          .includes(searchText.toLowerCase()),
      ) || passAuditReport;
    this.setState({
      filterPassAuditReport: finalFilterData,
    });
  };

  getPopupContent = () => {
    const {popup} = this.state;
    switch (popup.type) {
      case POPUP_CONSTANTS.SPINNER_POPUP: {
        return <Spinner name="cube-grid" color="#0045E6" {...popup} />;
      }
      case POPUP_CONSTANTS.SIMPLE_POPUP: {
        return <Popup {...popup} />;
      }
      default: {
        console.warn('getPopupContent', popup.type);
        return null;
      }
    }
  };

  componentDidMount() {
    //this.fetchPassAuditReport();
    this.getData();
  }

  render() {
    const viewProps = this.getProps();
    const {popup} = this.state;
    return (
      <>
        {popup ? (
          <PopupContainer> {this.getPopupContent()} </PopupContainer>
        ) : null}
        <ViewRenderer {...viewProps} />
      </>
    );
  }
}
export default PassAuditReport;
